import * as React from "react";
import { Field } from "formik";
import { Input } from "components/bootstrap";
import { loadStreamsDataLakeOptions } from "data-lake/hooks/useDataLakes";
import PaginatedSelect from "components/common/Select/PaginatedSelect";
const StreamSelectField = ({ disabled = false, value = [], onChange }) => {
  const selectedStreams = value.join(",");
  const placeholder = "Select streams the retrieval operation should include.";
  const handleChange = (selected) => {
    onChange(selected === "" ? [] : selected.split(","));
  };
  return /* @__PURE__ */ React.createElement(Field, { name: "stream_ids" }, ({ name }) => /* @__PURE__ */ React.createElement(Input, { id: name, label: "Streams" }, /* @__PURE__ */ React.createElement(
    PaginatedSelect,
    {
      placeholder,
      displayKey: "key",
      disabled,
      inputId: "streams-filter",
      value: selectedStreams,
      onLoadOptions: loadStreamsDataLakeOptions,
      multi: false,
      onChange: handleChange
    }
  )));
};
export default StreamSelectField;
